export default "/public/app-main/static/image/532d98b3656dacab8dfe5ef1e9e1d598.png";